<script setup>
import { ref, getCurrentInstance, watch } from 'vue'
import { RESOLVER_URL } from '@/main'
import PubchemSections from '@/components/pubchem/PubchemSections.vue'

const props = defineProps({
  chemical: {
    type: [Object, String],
    required: true,
  },
  section: {
    type: String,
    default: null,
  },
  titleFilter: {
    type: Array,
    required: false,
  },
})

const result = ref(null)
const loading = ref(false)

const emit = defineEmits(['has-result'])

const instance = getCurrentInstance()
const $axios = instance && instance.proxy ? instance.proxy.$axios : null

const getSection = () => {
  if (!$axios) return

  const id =
    typeof props.chemical === 'string'
      ? props.chemical
      : props.chemical.sid ||
        props.chemical.cid ||
        props.chemical.casrn ||
        props.chemical.inchiKey ||
        props.chemical.name

  if (!id) return
  loading.value = true

  return $axios
    .get(`${RESOLVER_URL}/pubchem-section?query=${encodeURIComponent(id)}&section=${encodeURIComponent(props.section)}`)
    .then((response) => {
      if (response.data[0]?.swr?.length) {
        result.value = [...response.data[0].swr].sort((f1, f2) => f1.cid - f2.cid)[0]
        emit('has-result', !!result.value)
      }
    })
    .catch((error) => console.error('Error fetching pubchem section:', error))
    .finally(() => (loading.value = false))
}

watch(
  () => [props.chemical, props.section],
  () => {
    if (props.chemical && props.section) getSection()
  },
  { immediate: true },
)
</script>

<template>
  <v-card
    v-if="result && !loading"
    max-width="30rem"
    max-height="30rem"
    min-width="25rem"
    class="d-flex flex-column"
  >
    <v-card-subtitle class="bg-light font-weight-bold py-2">
      {{ (chemical.name || chemical.casrn) + ' | ' + section }}
    </v-card-subtitle>

    <v-card-text
      class="d-flex flex-column"
      style="min-height: 0"
    >
      <PubchemSections
        :section="result.section"
        :references="result.references"
        :title-filter="titleFilter"
        paginated
      />
    </v-card-text>
  </v-card>

  <div
    v-else-if="loading"
    class="text-center p-2"
  >
    <v-progress-circular indeterminate />
  </div>
</template>
